import { Fragment, useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

const TabsComponent = ({ tabs, onChangeTab = () => {}, defaultTab, sx }) => {
  const [valueTab, setValueTab] = useState(0);

  const handleChange = (event, newValue) => {
    setValueTab(newValue);
    onChangeTab(newValue);
  };

  useEffect(() => {
    if (defaultTab) setValueTab(defaultTab);
  }, [setValueTab, defaultTab]);
  return (
    <Fragment>
      <Tabs
        value={valueTab}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
      >
        {tabs?.map((tab, index) => (
          <Tab
            key={tab?.id ?? index}
            label={tab?.label}
            {...a11yProps(tab?.id || index)}
          />
        ))}
      </Tabs>
      {tabs?.map((tab, index) => (
        <TabPanel
          key={tab?.id ?? index}
          value={valueTab}
          index={tab?.id || index}
          sx={sx}
        >
          {tab?.children}
        </TabPanel>
      ))}
    </Fragment>
  );
};

export default TabsComponent;

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, sx, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={sx}>{children}</Box>}
    </div>
  );
}
